module.exports = __webpack_public_path__ + "static/media/Nincada_gaussian2.0d9b8668.png";